import {Routes} from '@angular/router';

import {UserSourceComponent} from './components/user-source/user-source.component';


export const USER_ROUTES: Routes = [
    {path: 'users/sources', component: UserSourceComponent}
];



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/user/user.routes.ts